import { LOCAL_STORAGE_KEY as FACILITY_STORAGE_KEY } from './modules/facility/facility-reducer';

export const persistStateToSession = (key, state) => {
  sessionStorage.setItem(key, JSON.stringify(state));
};

export const getStateFromSession = (key, defaultState) => {
  const storedState = sessionStorage.getItem(key);
  let state;
  if (storedState) {
    state = JSON.parse(storedState);
  } else {
    state = defaultState;
  }
  return state;
};

export const persistStateToLocal = (key, state) => {
  localStorage.setItem(key, JSON.stringify(state));
};

export const getStateFromLocal = (key, defaultState) => {
  const storedState = localStorage.getItem(key);
  let state;
  if (storedState) {
    state = JSON.parse(storedState);
  } else {
    state = defaultState;
  }
  return state;
};

export const clearUserSession = () => new Promise((resolve) => {
  const facilitySessionValue = sessionStorage.getItem(FACILITY_STORAGE_KEY);
  sessionStorage.clear();
  sessionStorage.setItem(FACILITY_STORAGE_KEY, facilitySessionValue);
  resolve();
});

